import { useDays, TODAY } from './days';

export function useCalendarUtils() {
  return {
    TODAY,
    ...useDays(),
  };
}
